import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectList = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.PageProjectList />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectList = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectList />
    </Suspense>
  );
};
